/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleDisclosureLabel from 'base/components/standalone/ArticleDisclosureLabel';

export const DynamicStandaloneArticleDisclosureLabel = StandaloneArticleDisclosureLabel;
export type DynamicStandaloneArticleDisclosureLabelProps = PropsFromComponent<typeof StandaloneArticleDisclosureLabel>;

export const DynamicStandaloneArticleDisclosureLabelWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleDisclosureLabel => {
    return function DynamicStandaloneArticleDisclosureLabel(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleDisclosureLabel');
        return <StandaloneArticleDisclosureLabel {...mergeProps({ options: { theme } }, props)} />;
    }
}